import api from "./api";
import TokenService from "./token.service";
import localdataService from "./localdata.service";
const register = (username, email, password) => {
  return api.post("/auth/signup", {
    username,
    email,
    password,
  });
};

const login = async (credential) => {
  return await api.post("/token/", credential).then((response) => {
    if (response.data.access_token) {
      TokenService.setUser(response.data);
      //   TokenService.setUser(response.data.access_token);
      return true;
    }

    return false;
  });
};

const verify_otp = async (otp) => {
  return await api.post("/verify_otp_for_login/", otp).then((response) => {
    if (response.data.access_token) {
      TokenService.setUser(response.data);
      //   TokenService.setUser(response.data.access_token);
      return true;
    }

    return false;
  });
};
const getOtp = async (credential) => {
  return await api
    .get("/send_otp_for_login/?key=" + credential)
    .then((response) => {
      // if (response.data.success) {
      //   TokenService.setUser(response.data);
      //   //   TokenService.setUser(response.data.access_token);
      //   return {success:true,address:response.data.response};
      // }

      return response.data;
    });
};

const logout = async () => {
  try {
    await api.get("/users/sign-out/");
  } catch (ex) {
    console.log(ex);
  } finally {
    TokenService.removeUser();
    window.location = "/";
  }
};

const getCurrentUser = async () => {
  try {
    return await api.get("/users/me/").then((response) => {
      if (response.data.kapid_id) {
        localdataService.setCurrentUser(response.data.kapid_id);
        return response.data;
      }

      return false;
    });
  } catch (ex) {
    return false;
  }
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  getOtp,
  verify_otp,
};

export default AuthService;
